import PrimaryButton from '@/components/Buttons/PrimaryButton';
import useInertiaData from '@/hooks/useInertiaData';
import useRoutes from '@/hooks/useRoutes';
import { Play } from 'lucide-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const ContinueLearning = () => {
    const { t } = useTranslation();

    const { user, account_paused } = useInertiaData();

    if (account_paused || !user?.last_class_viewed) {
        return null;
    }

    const lastClassViewed = useMemo(() => {
        return user.last_class_viewed;
    }, [user]);

    const lastCourseViewed = useMemo(() => {
        return user.last_course_viewed;
    }, [user]);

    if (!lastClassViewed || !lastCourseViewed) {
        return null;
    }

    const { route } = useRoutes();

    return (
        <div className="continue-learning-card">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
                <div className="min-w-0 space-y-1">
                    <h2 className="text-base font-bold text-gray-900 dark:text-white sm:text-lg">
                        {t('continueWhereYouLeftOff')}
                    </h2>
                    <p className="truncate text-sm text-gray-600 dark:text-neutral-300">
                        {lastClassViewed.title}
                    </p>
                </div>
                <div className="shrink-0">
                    <PrimaryButton
                        as="link"
                        href={route('class-detail', {
                            slug: lastCourseViewed.slug,
                            class_id: lastClassViewed.id.toString(),
                        }).toString()}
                        size="md"
                    >
                        <Play size={18} />
                        <span>{t('home.continueLearning')}</span>
                    </PrimaryButton>
                </div>
            </div>
        </div>
    );
};

export default ContinueLearning;
